var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "filter_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472 168H40a24 24 0 0 1 0-48h432a24 24 0 0 1 0 48zm-80 112H120a24 24 0 0 1 0-48h272a24 24 0 0 1 0 48zm-96 112h-80a24 24 0 0 1 0-48h80a24 24 0 0 1 0 48z"
  })));
};
export { SvgFilter as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpb25pY29uIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHRpdGxlPkZpbHRlcjwvdGl0bGU+PHBhdGggZD0iTTQ3MiAxNjhINDBhMjQgMjQgMCAwMTAtNDhoNDMyYTI0IDI0IDAgMDEwIDQ4ek0zOTIgMjgwSDEyMGEyNCAyNCAwIDAxMC00OGgyNzJhMjQgMjQgMCAwMTAgNDh6TTI5NiAzOTJoLTgwYTI0IDI0IDAgMDEwLTQ4aDgwYTI0IDI0IDAgMDEwIDQ4eiIvPjwvc3ZnPg==";